import useSponsors from "../hooks/useSponsors";
import SponsorLogo from "./SponsorLogo";

function ImgTable(props) {
    const { data: sponsors } = useSponsors();
    if (!sponsors) return null;
    return (
        <div className="w-full flex flex-row flex-wrap">
            {sponsors.map((sponsor, index) => {
                return (
                    <div className="p-1.5 w-full lg:w-1/4 object-contain " key={index}>
                        <a href={sponsor.link} target="_blank" rel="noreferrer" >
                            <div className="bg-blue-dark w-full p-0.5 h-56 cursor-pointer">
                                <SponsorLogo src={sponsor.img} />
                            </div>
                        </a>
                    </div>
                )
            })}
        </div>
    );
}

export default ImgTable;
